var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { FinancialPeriod } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from '../ApiService';
var FinancialPeriodService = /** @class */ (function (_super) {
    __extends(FinancialPeriodService, _super);
    function FinancialPeriodService() {
        var _this = _super.call(this) || this;
        _this.financialPeriodsRoot = 'financial_periods';
        _this.successMessage = '';
        return _this;
    }
    FinancialPeriodService.prototype.useFinancialPeriods = function () {
        var _this = this;
        return useQuery([queries.accounting.financialPeridos], function () {
            return _this.get(_this.financialPeriodsRoot);
        }, {
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(FinancialPeriod, data);
            }
        });
    };
    FinancialPeriodService.prototype.useCloseFinancialPeriod = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var id = _a.id, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.put(_this.financialPeriodsRoot + '/' + id + '/close');
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.accounting.financialPeridos);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    FinancialPeriodService.prototype.useOpenFinancialPeriod = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.post(_this.financialPeriodsRoot + '/open');
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.accounting.financialPeridos);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    FinancialPeriodService.getInstance = function () {
        if (!FinancialPeriodService.financialPeriodService) {
            FinancialPeriodService.financialPeriodService = new FinancialPeriodService();
        }
        return FinancialPeriodService.financialPeriodService;
    };
    return FinancialPeriodService;
}(ApiService));
export default FinancialPeriodService;
